import { useContext } from "react"
import EventsTrackParentIdContext from "../components/containers/EventsTrack/EventsTrackParentIdContext";

const useEventsTrackParentId = () => useContext(EventsTrackParentIdContext);

export default useEventsTrackParentId;